import { declareExportAllDeclaration } from '@babel/types';

export default {
    template: [
        'autocomplete_template',
        (data) => {
            return {
                id: data.suggestion,
                suggestion: data.suggestion,
                type: data.type,
            };
        },
    ],

    GET: {},
};
